import { j as r } from "../../../../../../jsx-runtime.BREq8dyb.js";
import { Stack as s } from "@mui/joy";
import { memo as p } from "react";
import "../../../../contexts/DatasetContext/DatasetContext.js";
import "../../../../contexts/FeatureContext/FeatureContext.js";
import { useFile as l } from "../../../../contexts/FileContext/FileContext.js";
import "../../../../contexts/IntrospectionContext/IntrospectionContext.js";
import "../../../../contexts/NavigatorContext/NavigatorContext.js";
import "../../../../contexts/OptionsContext/OptionsContext.js";
import "../../../../contexts/SchemaContext/SchemaContext.js";
import "../../../../contexts/TypificationContext/TypificationContext.js";
import "../../../../contexts/WorkerContext/WorkerContext.js";
import f from "../../../Prepper/components/FileHasHeaderRadioGroup/FileHasHeaderRadioGroup.js";
import u from "../../../Prepper/components/FileValuesDelimiterRadioGroup/FileValuesDelimiterRadioGroup.js";
import d from "../../../Prepper/components/FileDecimalSeparatorRadioGroup/FileDecimalSeparatorRadioGroup.js";
const F = p(() => {
  const {
    fileHasHeader: o,
    fileValuesDelimiter: e,
    setFileHasHeader: i,
    setFileValuesDelimiter: t,
    setFileSeparators: m,
    fileDecimalSeparator: a
  } = l();
  return /* @__PURE__ */ r.jsxs(s, { children: [
    /* @__PURE__ */ r.jsx(f, { fileHasHeader: o, setFileHasHeader: i }),
    /* @__PURE__ */ r.jsx(u, { fileValuesDelimiter: e, setFileValuesDelimiter: t }),
    /* @__PURE__ */ r.jsx(d, { fileDecimalSeparator: a, setFileSeparators: m })
  ] });
});
F.displayName = "FormatDataControls";
export {
  F as default
};
//# sourceMappingURL=FormatDataControls.js.map
